import { render, staticRenderFns } from "./OrderProcess.vue?vue&type=template&id=1206e3fa&scoped=true"
import script from "./OrderProcess.vue?vue&type=script&lang=ts"
export * from "./OrderProcess.vue?vue&type=script&lang=ts"
import style0 from "./OrderProcess.vue?vue&type=style&index=0&id=1206e3fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206e3fa",
  null
  
)

export default component.exports